// extracted by mini-css-extract-plugin
module.exports = {"cv-container":"CV_cv-container__1iq_d","main":"CV_main__33Hqc"};